<script>
    import { createEventDispatcher } from 'svelte';

    export let items = [];
    export let value = '';
    export let placeholder = 'Поиск или введите ФИО...';
    export let invalid = false;
    export let id = '';

    const dispatch = createEventDispatcher();

    let isOpen = false;

    $: filteredItems = items.filter(item => {
        const fio = item?.fio || item?.name || '';
        if (!fio) return false;
        const q = (value ?? '').trim().toLowerCase();
        if (!q) return true;
        return fio.toLowerCase().includes(q);
    });

    function selectItem(item) {
        const fio = item?.fio || item?.name;
        if (!fio) return;
        value = fio;
        isOpen = false;
        dispatch('input');
        dispatch('select', item);
    }

    function handleInput() {
        isOpen = true;
    }

    function handleFocus() {
        isOpen = true;
    }

    function handleBlur() {
        setTimeout(() => {
            isOpen = false;
        }, 200);
    }

    function clearValue() {
        value = '';
        isOpen = true;
        dispatch('input');
    }
</script>

<div class="fio-search-wrapper">
    <div class="search-wrap">
        <input
                type="text"
                {id}
                class="form-control"
                class:is-invalid={invalid}
                {placeholder}
                bind:value
                autocomplete="off"
                on:input={handleInput}
                on:input
                on:focus={handleFocus}
                on:blur={handleBlur}
        />
        {#if value}
            <button type="button" class="clear-btn" aria-label="Очистить" on:click={clearValue}>✕</button>
        {/if}
    </div>

    {#if isOpen && filteredItems.length > 0}
        <ul class="fio-dropdown" role="listbox">
            {#each filteredItems as item (item.id ?? item.fio ?? item.name)}
                <li class="fio-option" role="option" aria-selected={(item.fio || item.name) === value}>
                    <button
                            type="button"
                            class="fio-option-btn"
                            class:is-selected={(item.fio || item.name) === value}
                            on:mousedown|preventDefault={() => selectItem(item)}
                    >
                        <span class="option-name">{item.fio || item.name}</span>
                    </button>
                </li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .fio-search-wrapper {
        position: relative;
        width: 100%;
    }

    .search-wrap {
        position: relative;
        display: flex;
        align-items: center;
    }

    .search-wrap :global(.form-control) {
        padding-right: 32px;
    }

    .clear-btn {
        position: absolute;
        right: 10px;
        background: none;
        border: none;
        cursor: pointer;
        color: #9ca3af;
        font-size: 14px;
        line-height: 1;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        transition: background 0.15s, color 0.15s;
    }

    .clear-btn:hover {
        background: #f3f4f6;
        color: #374151;
    }

    .fio-dropdown {
        position: absolute;
        top: calc(100% + 4px);
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #d4d1ca;
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        list-style: none;
        margin: 0;
        padding: 4px 0;
        max-height: 220px;
        overflow-y: auto;
        z-index: 100;
    }

    .fio-option {
        margin: 0 4px;
        padding: 0;
        list-style: none;
    }

    .fio-option-btn {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 9px 14px;
        cursor: pointer;
        font-size: 14px;
        color: #28251d;
        background: none;
        border: none;
        text-align: left;
        transition: background 0.12s;
        border-radius: 4px;
    }

    .fio-option-btn:hover {
        background-color: #f3f0ec;
    }

    .fio-option-btn.is-selected {
        background-color: #e8f4f5;
        color: #01696f;
        font-weight: 500;
    }

    .option-name {
        flex: 1;
    }
</style>
